<script lang="ts">
  import {
    getSwiperButtonGroupStyle,
    getSwiperButtonStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type {
    ISwiperButtonGroupChevron,
    ISwiperButtonGroupNode,
    PartialNode,
  } from "@shared/common/node/type";
  import { getCurrentDocumentNode, getStore } from "../../context";

  export let node: PartialNode<ISwiperButtonGroupNode>;
  let nodeStyle: PartialNode<ISwiperButtonGroupChevron>;
  let hideButtonGroup: boolean = false;

  const {
    swiperInstance,
    reactionEventListener: dispatchReactionEvent,
    childrenNodeData,
  } = getStore();

  const documentNode = getCurrentDocumentNode();

  $: {
    if (node.style) {
      nodeStyle = node.style;
    }
  }

  $: {
    hideButtonGroup = !!$childrenNodeData && $childrenNodeData.length === 1;
  }

  function handleSlidePrev(e: Event) {
    $swiperInstance.slidePrev();
    dispatchReactionEvent({
      documentNode,
      element: e.target as HTMLElement,
      node,
      data: {
        nodeId: node.id ?? "",
        nodeName: `${node.name}_PREV`,
        trigger: { type: "ON_CLICK" },
        action: { type: "SLIDE", direction: "PREV" },
      },
      // eslint-disable-next-line no-console
    }).catch((e) => console.error(e));
  }

  function handleSlideNext(e: Event) {
    $swiperInstance.slideNext();
    dispatchReactionEvent({
      documentNode,
      element: e.target as HTMLElement,
      node,
      data: {
        nodeId: node.id ?? "",
        nodeName: `${node.name}_NEXT`,
        trigger: { type: "ON_CLICK" },
        action: { type: "SLIDE", direction: "NEXT" },
      },
      // eslint-disable-next-line no-console
    }).catch((e) => console.error(e));
  }
</script>

<div
  style={styleToString({
    ...getSwiperButtonGroupStyle(node),
    ...(hideButtonGroup && {
      visibility: "hidden",
      pointerEvents: "none",
    }),
  })}
>
  <!-- a11y 이슈로 keydown 도 추가. @see https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/click-events-have-key-events.md -->
  <div
    role="button"
    tabindex="0"
    style={styleToString({
      ...getSwiperButtonStyle(nodeStyle),
      ...(hideButtonGroup && { cursor: "default" }),
    })}
    on:click={handleSlidePrev}
    on:keydown={handleSlidePrev}
  >
    <!--left Chevron  -->
    <svg height="100%" viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg"
      ><path
        d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z"
        fill="currentColor"
        style="transform-origin: center; transform:rotate(180deg)"
      /></svg
    >
  </div>
  <div
    role="button"
    tabindex="0"
    style={styleToString({
      ...getSwiperButtonStyle(nodeStyle),
      ...(hideButtonGroup && { cursor: "default" }),
    })}
    on:click={handleSlideNext}
    on:keydown={handleSlideNext}
  >
    <!-- right Chevron -->
    <svg height="100%" viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg"
      ><path
        d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z"
        fill="currentColor"
      /></svg
    >
  </div>
</div>
